import React from 'react';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockButton from '../components/GuideMockButton';
import GuideMockContainer from '../components/GuideMockContainer';
import GuideMockSelect from '../components/GuideMockSelect';
import GuideMockTextField from '../components/GuideMockTextField';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideAssessmentDispose: React.FC = () => {
  return (
    <GuidePageLayout
      title="資産を除却する"
      description="廃棄・故障等で不要になった資産を除却（論理削除）します。"
      breadcrumbs={[{ label: '資産管理', path: '/guide/assessment/overview' }]}
    >
      <GuideSection title="前提">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['必要な権限', '管理者 / 管理部門'],
            ['ログイン状態', 'ログイン済みであること'],
            ['対象資産', '除却されていないこと'],
          ]}
        />
      </GuideSection>

      <GuideSection title="手順">
        <GuideStepList
          steps={[
            { label: '資産管理画面で対象の資産を検索・選択する' },
            {
              label: '詳細画面のフッターにある「除却」ボタンを押下する',
              content: (
                <GuideMockContainer label="フッターボタン（詳細表示時）">
                  <GuideMockButton label="除却" color="error" startIcon={<DeleteForeverIcon />} />
                </GuideMockContainer>
              ),
            },
            {
              label: '除却情報を入力する',
              content: (
                <GuideMockContainer label="除却情報フォーム">
                  <Grid container spacing={2}>
                    <Grid size={6}>
                      <GuideMockSelect
                        label="除却理由"
                        options={['廃棄', '故障', '紛失', 'その他']}
                        required
                      />
                    </Grid>
                    <Grid size={6}>
                      <GuideMockTextField label="除却日" required />
                    </Grid>
                    <Grid size={12}>
                      <GuideMockTextField label="除却詳細" />
                    </Grid>
                  </Grid>
                </GuideMockContainer>
              ),
            },
            {
              label: '確認入力欄に「delete」と入力し、「実行」ボタンを押下する',
            },
          ]}
        />
      </GuideSection>

      <GuideSection title="入力項目">
        <GuideTable
          headers={['項目名', '必須', '形式', '備考']}
          rows={[
            ['除却理由', '必須', 'プルダウン', '廃棄 / 故障 / 紛失 / その他'],
            ['除却日', '必須', 'テキスト（日付）', '除却した日付'],
            ['除却詳細', '任意', 'テキスト', '補足情報'],
          ]}
        />
      </GuideSection>

      <GuideSection title="注意事項">
        <Stack spacing={1}>
          <GuideInfoBox type="warning">除却後は資産情報を更新できません。</GuideInfoBox>
          <GuideInfoBox type="warning">除却は取り消せません。慎重に操作してください。</GuideInfoBox>
          <GuideInfoBox>
            除却の確認ダイアログでは「delete」の入力が求められます。正確に入力しないと「実行」ボタンが活性化しません。
          </GuideInfoBox>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideAssessmentDispose;
